import changeEmailNotificationSubscription from '@commonJs/actions/changeEmailNotificationSubscription';

$(document).on(
    'change',
    '#email-notification-subscription',
    { uri: '/portal/api/toggle-email-notification-subscription' },
    changeEmailNotificationSubscription
);
